import { queryClient } from "@/lib/query";
import { request } from "@/lib/request";
import { TodoVault } from "@/lib/types";
import { useMutation } from "@tanstack/react-query";

export const useUpdateTodoVault = () => {
  return useMutation({
    mutationFn: async (data: { vaultId: string; data: { name: string } }) => {
      const res = await request.put<{ data: TodoVault | void }>(
        `/internal/todos/vaults/${data.vaultId}`,
        data.data,
      );
      queryClient.invalidateQueries({
        queryKey: ["todos", "vaults"],
      });
      return res.data.data;
    },
  });
};
